import { Box, styled } from '@mui/material';

export const BundleHeaderBannerHighlightCoverStyle = styled(Box)`
  position: relative;
  border-radius: 8px;
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    width: 487px;
    height: 274px;
  }
`;

export const BundleHeaderBannerMultipleCoverStyle = styled(Box)`
  height: max-content;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 4px;
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    grid-template-rows: 135px 135px;
  }
`;
